import moment from 'moment';
import { getMonthName } from '../../../utils/utils';
import LZString from 'lz-string';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import collections from '../../../constants/FirestoreCollections';
const MySwal = withReactContent(Swal);

const createRow = (desc, ctdad, unit, price, detail) => {
  if (detail) return { desc, ctdad, unit, price, detail };
  return { desc, ctdad, unit, price };
};
export function removeAccents(str) {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
export function setTemplatesInBicUtility(prices, templates) {
  try {
    // eslint-disable-next-line no-undef
    const idRecordatorio = JSON.parse(localStorage.getItem('idRecordatorio'));
    // eslint-disable-next-line no-undef
    const utilityTemplates = JSON.parse(localStorage.getItem('utilityTemplates'));
    if (templates?.length > 0) {
      templates
        .filter((template) => {
          if (utilityTemplates.some((item) => item.templateId === template.id)) {
            return template.category.toLowerCase() === 'utility';
          }
        })
        .map((template) => {
          const exists = prices.priceBICUtility.utility.some(
            (item) => item.templateId === template.id,
          );
          if (!exists)
            if (
              !(
                template.id !== idRecordatorio &&
                removeAccents(template.name) === 'confirmacion/cancelacion'
              )
            )
              prices.priceBICUtility.utility.push({
                templateId: template.id,
                templateName:
                  removeAccents(template.name) === 'confirmacion/cancelacion'
                    ? template.name
                    : template.displayName,
                templatePrice: 0,
              });
        });
    }
  } catch (error) {
    console.error('setTemplatesInBicUtility', error);
  }
}

const getBICDetailsRows = (templates) => {
  // eslint-disable-next-line no-undef
  const utilityTemplates = JSON.parse(localStorage.getItem('utilityTemplates'));
  const categorizedTemplates = {
    utility: [],
    marketing: [],
    authentication: [],
  };

  if (templates?.length > 0) {
    templates.forEach((template) => {
      if (utilityTemplates.some((item) => item.templateId === template.id)) {
        if (template.category.toLowerCase() === 'utility') {
          if (
            removeAccents(template.name) !== removeAccents('alta_paciente') &&
            removeAccents(template.name) !== removeAccents('activacion_chat')
          )
            categorizedTemplates.utility.push(template);
        } else if (template.category.toLowerCase() === 'marketing') {
          categorizedTemplates.marketing.push(template);
        } else if (template.category.toLowerCase() === 'authentication') {
          categorizedTemplates.authentication.push(template);
        }
      }
    });
  }

  return categorizedTemplates;
};

export function checkInfoAndGenerateRows(info, templates) {
  try {
    const rows = [];
    const bicDetailsRows = getBICDetailsRows(templates);
    if (info.totalsFromGupshup && info.totalsFromGupshup.totalUic >= 0)
      rows.push(
        createRow(
          'Chats WSP',
          info.totalsFromGupshup.totalUic,
          info.prices.chatWspPrice,
          info.totalsPricesBilling.chatsWsp,
        ),
      );
    if (info.chatsWeb >= 0)
      rows.push(
        createRow(
          'Chats Web',
          info.chatsWeb,
          info.prices.chatWebPrice,
          info.totalsPricesBilling.chatsWeb,
        ),
      );
    if (info.utility?.length > 0) {
      let setTotal = 0;

      const auxPriceBICUtility = JSON.parse(JSON.stringify(info.utility));

      const filteredUtility = auxPriceBICUtility.filter((object) => {
        const isAllowedTemplateName =
          removeAccents(object.templateName) === removeAccents('Alta de paciente') ||
          removeAccents(object.templateName) === removeAccents('Activación de chat') ||
          removeAccents(object.templateName) === 'confirmacion/cancelacion';

        const hasConfirmationCancellation = auxPriceBICUtility.some(
          (obj) => obj.templateName === 'confirmacion/cancelacion',
        );
        const isUtilityTemplate = bicDetailsRows.utility.find(
          (obj) => obj.id === object.templateId,
        );
        if (!hasConfirmationCancellation && !isAllowedTemplateName && isUtilityTemplate) {
          object.templateName = 'confirmacion/cancelacion';
          // eslint-disable-next-line no-undef
          localStorage.setItem('idRecordatorio', JSON.stringify(object.templateId));
        }
        return (
          isAllowedTemplateName ||
          (!hasConfirmationCancellation && !isAllowedTemplateName && isUtilityTemplate)
        );
      });

      info.utility = filteredUtility;
      info.utility.map((util) => {
        setTotal = util.notifications;
        const templateInfo =
          info.prices.priceBICUtility.utility.length > 0
            ? info.prices.priceBICUtility.utility.find(
                (item) => item.templateId === util.templateId,
              ) || 0
            : 0;
        if (
          removeAccents(util.templateName) === 'confirmacion/cancelacion' ||
          util.templateName === null ||
          removeAccents(util.templateName).startsWith('confirmacion/cancelacion')
        ) {
          const bicUtilityRecordatoriosIndex = rows.findIndex(
            (row) => row.desc === '(BIC) Utility Notificaciones',
          );
          if (bicUtilityRecordatoriosIndex === -1) {
            setTotal = info.totalsFromGupshup.totalRecordatorios;
            if (setTotal > 0) {
              rows.push(
                createRow(
                  `(BIC) Utility Notificaciones`,
                  setTotal,
                  templateInfo.templatePrice,
                  info.totalsPricesBilling.recordatorios || 0,
                  bicDetailsRows.utility,
                ),
              );
            }
          }
        } else {
          if (setTotal > 0) {
            rows.push(
              createRow(
                `(BIC) Utility ${util.templateName}`,
                setTotal,
                templateInfo.templatePrice,
                info.totalsPricesBilling[`BICUtility_${templateInfo.templateName}`] || 0,
              ),
            );
          }
        }
      });
    }
    if (info.totalsFromGupshup?.totalBICMarketing > 0)
      rows.push(
        createRow(
          '(BIC) Marketing',
          info.totalsFromGupshup.totalBICMarketing,
          info.prices.priceBICMkt,
          info.totalsPricesBilling.BICMarketing,
          bicDetailsRows.marketing,
        ),
      );
    if (info.totalsFromGupshup?.totalBICAuth > 0)
      rows.push(
        createRow(
          '(BIC) Auth',
          info.totalsFromGupshup.totalBICAuth,
          info.prices.priceBICAuth,
          info.totalsPricesBilling.BICAuth,
          bicDetailsRows.authentication,
        ),
      );

    return rows;
  } catch (err) {
    console.error('Error en Dashboard/hooks ===> checkInfoAndGenerateRows', err);
  }
}

export function checkStringsFromObject(object) {
  try {
    const updatedObject = { ...object };
    for (const key in updatedObject) {
      if (typeof updatedObject[key] === 'string') {
        updatedObject[key] = parseFloat(updatedObject[key]);
      }
    }
    return updatedObject;
  } catch (error) {
    console.error('checkStringsFromObject', error);
  }
}

export function formatGestionName(gestion) {
  if (typeof gestion !== 'string') {
    console.warn('formatGestionName >> El argumento debe ser una cadena');
    return '';
  }
  // Reemplazar guiones bajos (_), puntos (.) y paréntesis '()'
  gestion = gestion.replace(/[_().]/g, ' ');
  // Reemplaza todas las letras aisladas al inicio
  return gestion
    .replace(/(^|\s)[A-Za-z](?=\s|$)/g, ' ')
    .trim()
    .toUpperCase();
}

export const getTime = (time) => {
  const _date = moment(time);
  const month = _date.get('month');
  const year = _date.get('year');
  const monthName = getMonthName(month);
  return `${monthName} ${year}`;
};

export const getTimesArray = (objectChart) => {
  const timesArray = [];
  for (const key in objectChart) {
    if (objectChart[key]) {
      timesArray.push(key);
    }
  }
  timesArray.sort().reverse();
  return timesArray;
};

export const getColorForData = (data) => {
  switch (data) {
    case 1:
    case 'TURNO':
    case 'Whatsapp':
    case 'CONFIRMADO':
      return 'rgba(75, 192, 192, 0.8)'; // Aqua color

    case 2:
    case 'CONSULTA':
    case 'NO RESPONDIDO':
      return 'rgba(255, 205, 86, 0.8)'; // Yellow color

    case 3:
    case 'Webchat':
      return 'rgba(255, 159, 64, 0.8)'; // Orange color

    case 4:
    case 'CANCELACION':
    case 'CANCELADO':
      return 'rgba(255, 99, 132, 0.8)'; // Red color

    default:
      return 'rgba(54, 162, 235, 0.8)'; // Blue color
  }
};

export const adjustPercentages = (datos, nameProperty, totalProperty) => {
  // Paso 1: Calcular los porcentajes redondeados
  const totalAmount = datos.reduce((sum, item) => sum + item[totalProperty], 0);
  const roundedPercentages = datos.map((item) => ({
    ...item,
    percentage: Math.round((item[totalProperty] / totalAmount) * 100),
  }));

  // Paso 2: Calcular la diferencia
  const sumPercentages = roundedPercentages.reduce((sum, item) => sum + item.percentage, 0);
  const difference = 100 - sumPercentages;

  // Paso 3: Ajustar los porcentajes para que sumen exactamente 100%
  if (difference !== 0) {
    // Ordenar por el valor decimal del porcentaje original para minimizar el error
    roundedPercentages.sort((a, b) => {
      const diffA = (a[totalProperty] / totalAmount) * 100 - a.percentage;
      const diffB = (b[totalProperty] / totalAmount) * 100 - b.percentage;
      return diffA - diffB;
    });

    // Ajustar los porcentajes
    for (let i = 0; i < Math.abs(difference); i++) {
      roundedPercentages[i % roundedPercentages.length].percentage += Math.sign(difference);
    }
  }

  // Devuelve el resultado con los porcentajes ajustados
  return roundedPercentages.map((item) => ({
    ...item,
    [nameProperty]: item[nameProperty],
    percentage: item.percentage,
  }));
};

export const handleConfirmSwal = async (message) => {
  return MySwal.fire({
    text: message,
    confirmButtonText: 'Sí',
    showConfirmButton: true,
    showCancelButton: true,
    cancelButtonColor: '#d33',
    icon: 'warning',
    customClass: {
      container: 'gap: 100px',
    },
  });
};

/**
 * Fetches data from an API and Firestore based on the initial date and organization ID.
 *
 * @param {string} initialDate - The initial date in 'YYYY-MM' format.
 * @param {string} organizationId - The ID of the organization.
 * @param {Object} firestore - The Firestore object for database operations.
 * @returns {Object} An object containing chart data, KPI data, billing information, Firestore chart data, and Firestore data for specialities.
 */
export const fetchDataFromAPIAndFirestore = async (initialDate, organizationId, firestore) => {
  const initialDateTimestamp = firestore.Timestamp.fromDate(
    moment(initialDate, 'YYYY-MM').toDate(),
  );
  const endDateTimestamp = firestore.Timestamp.fromDate(
    moment(initialDate, 'YYYY-MM').endOf('month').toDate(),
  );
  const [
    apiResponseChart,
    apiResponseChartKpi,
    billingResponse,
    firestoreChartResponse,
    noSpecialtyResponse,
  ] = await Promise.allSettled([
    axios.post(`${process.env.REACT_APP_EXPORT_KPI}`, {
      type: 'getAllChartsData',
      organizationId,
      initialDate,
    }),
    axios.post(`${process.env.REACT_APP_EXPORT_KPI}`, {
      type: 'getAllKpisData',
      organizationId,
      initialDate,
    }),
    firestore
      .collection(collections.bills)
      .where('organizationId', '==', organizationId)
      .where('date', '==', initialDate)
      .get(),
    firestore
      .collection(collections.configurations)
      .where('name', '==', 'charts')
      .where('organizationId', '==', organizationId)
      .get(),
    firestore
      .collection(collections.gestiones)
      .where('type', '==', 'especialidades_no')
      .where('organizationId', '==', organizationId)
      .where('date', '>=', initialDateTimestamp)
      .where('date', '<=', endDateTimestamp)
      .get(),
  ]);

  const chartData = apiResponseChart.status === 'fulfilled' ? apiResponseChart.value.data : {};
  const kpiData = apiResponseChartKpi.status === 'fulfilled' ? apiResponseChartKpi.value.data : {};
  const kpiChats =
    billingResponse.status === 'fulfilled' && !billingResponse.value.empty
      ? { ...billingResponse.value.docs[0].data(), id: billingResponse.value.docs[0].id }
      : {};
  const chartsFirestoreData =
    firestoreChartResponse.status === 'fulfilled' && !firestoreChartResponse.value.empty
      ? firestoreChartResponse.value.docs[0].data()
      : null;
  const noSpecialtyFirestoreData =
    noSpecialtyResponse.status === 'fulfilled' && !noSpecialtyResponse.value.empty
      ? noSpecialtyResponse.value.docs
      : [];

  return { chartData, kpiData, kpiChats, chartsFirestoreData, noSpecialtyFirestoreData };
};

/**
 * Creates and returns a storage data object based on the provided parameters.
 * If chartsFirestoreData is available, updates the chartData with specific data.
 * If noSpecialtyFirestoreData is available, updates the chartData with specific data.
 * The final storage data includes organizationId, initialDate, kpiData, kpiChats, chartData, chartsFirestoreData,
 * noSpecialtyFirestoreData, and the lastCheckedDate set to the current moment in ISO format.
 *
 * @param {Object} params - An object containing chartData, kpiData, kpiChats, chartsFirestoreData, noSpecialtyFirestoreData,
 * organizationId, and initialDate.
 * @returns {Object} The storage data object with the updated chartData and additional information.
 */
export const createStorageData = ({
  chartData,
  kpiData,
  kpiChats,
  chartsFirestoreData,
  noSpecialtyFirestoreData,
  organizationId,
  initialDate,
}) => {
  if (chartsFirestoreData) {
    const kpiAnnualAppointmentsByMonth = chartsFirestoreData.gestionesByMonth?.reverse();
    // const kpiChatsStatisticsByMonth = chartsFirestoreData.chatsStatisticsByMonth;
    const kpiUniquesClientsByMonth = chartsFirestoreData.uniquesClientsByMonth;

    chartData = {
      ...chartData,
      kpiAnnualAppointmentsByMonth,
      // kpiChatsStatisticsByMonth,
      kpiUniquesClientsByMonth,
    };
  }

  if (noSpecialtyFirestoreData) {
    const noSpecialtyKpiByMonth = getNoSpecialtyKpisByMonth(noSpecialtyFirestoreData);
    chartData = {
      ...chartData,
      noSpecialtyKpiByMonth,
    };
  }

  const dataKpiStorage = {
    organizationId,
    initialDate,
    data: { ...kpiData, kpiChats, ...chartData, chartsFirestoreData, noSpecialtyFirestoreData },
    lastCheckedDate: moment().toISOString(),
  };

  return dataKpiStorage;
};

export const storeDataInLocalStorage = (type, key, dataStorage, dataStorageAnual = {}) => {
  const updatedDatatorage = {
    ...dataStorageAnual,
    [key]: dataStorage,
  };
  try {
    const compressedData = LZString.compressToUTF16(JSON.stringify(updatedDatatorage));
    // eslint-disable-next-line no-undef
    localStorage.setItem(type, compressedData);
  } catch (error) {
    console.warn('storeDataInLocalStorage', error);
    removeOldKpiStorageKeys(updatedDatatorage, true);
  }
};

export const getTopGestionesKpi = (data) => {
  if (!data) {
    console.info('getTopGestionesKpi >> No data ');
    return [];
  }
  const copydata = [...data];
  const filteredData = copydata.filter(
    (gestion) =>
      ![
        'NOTIFICACION',
        'STORAGE-IMAGE',
        'STORAGE-FILE',
        'SURVEY',
        'RECEIVE_IMAGE',
        'MEDIA.RECEIVE.IMAGE',
        'INTENTO CANCELACION',
        'SYSTEMMESSAGESWAPRO',
        'SYSTEMMESSAGESWASPE',
        'SYSTEMMESSAGESWEBPRO',
        'SYSTEMMESSAGESWEBSPE',
        'INSTITUTIONAL MESSAGE',
        'SYSTEM MESSAGE',
        'INSURANCE MESSAGE',
        'INTERNAL',
      ].includes(gestion.gestion.toUpperCase()),
  );
  const groupedGestiones = filteredData.reduce((acc, gestion) => {
    let upperGestion = gestion.gestion.toUpperCase();
    if (upperGestion.startsWith('SIN AGENDA -')) {
      upperGestion = 'SIN AGENDA';
    } else if (upperGestion.startsWith('INSURANCE MESSAGE PRIORITY')) {
      upperGestion = 'MENSAJE DE OS PRIORIZADO';
    } else if (
      /^SYSTEMMESSAGESWAPRO -|^SYSTEMMESSAGESWASPE -|^SYSTEMMESSAGESWEBPRO -|^SYSTEMMESSAGESWEBSPE -/.test(
        upperGestion,
      )
    ) {
      const startIndex = upperGestion.indexOf('-') + 1;
      upperGestion = upperGestion.substring(startIndex).trim();
    }
    const existingGestion = acc.find((item) => item.GESTION.toUpperCase() === upperGestion);
    if (existingGestion) {
      existingGestion.TOTAL += parseInt(gestion.total, 10);
    } else {
      acc.push({ GESTION: upperGestion, TOTAL: parseInt(gestion.total, 10) });
    }

    return acc;
  }, []);
  const totalSum = groupedGestiones.reduce((sum, gestion) => sum + gestion.TOTAL, 0);
  const kpiTopGestionesWithPercentage = groupedGestiones.map((gestion) => ({
    ...gestion,
    PERCENTAGE: ((gestion.TOTAL / totalSum) * 100).toFixed(2),
  }));

  const kpiTopGestiones = kpiTopGestionesWithPercentage
    .sort((a, b) => b.TOTAL - a.TOTAL)
    .slice(0, 15);

  return kpiTopGestiones;
};

export const getTopGestionesStatusEnAgenda = (data, topN = 15) => {
  if (!data) {
    console.info('getTopGestionesStatusEnAgenda >> No data ');
    return [];
  }
  const copydata = [...data];
  const enAgendaGestiones = copydata.filter(
    (gestion) => gestion.gestion.toUpperCase() === 'EN AGENDA',
  );

  const groupedGestiones = enAgendaGestiones.reduce((acc, curr) => {
    const specialty = curr.specialtyName.toUpperCase();
    const profName = curr.professionalName ? curr.professionalName.toUpperCase() : '';

    const specialtyEntry = acc.find((item) => item.GESTION.toUpperCase() === specialty);
    if (specialtyEntry) {
      specialtyEntry.TOTAL += parseInt(curr.total, 10);
    } else {
      acc.push({ GESTION: specialty, TOTAL: parseInt(curr.total, 10) });
    }

    if (profName) {
      const profNameEntry = acc.find((item) => item.GESTION.toUpperCase() === profName);
      if (profNameEntry) {
        profNameEntry.TOTAL += parseInt(curr.total, 10);
      } else {
        acc.push({ GESTION: profName, TOTAL: parseInt(curr.total, 10) });
      }
    }

    return acc;
  }, []);

  const kpiEnAgendaRes = groupedGestiones.sort((a, b) => b.TOTAL - a.TOTAL).slice(0, topN);

  return kpiEnAgendaRes;
};
export const getKpiAltasByMonth = (data) => {
  if (!data) {
    console.info('getKpiAltasByMonth >> No data ');
    return [];
  }

  const copydata = [...data];

  const altaGestiones = copydata.filter((gestion) =>
    gestion.gestion.toUpperCase().startsWith('ALTA'),
  );

  const alta = altaGestiones.find((gestion) => gestion.gestion.toUpperCase() === 'ALTA');
  const altaCompleta = altaGestiones.find(
    (gestion) => gestion.gestion.toUpperCase() === 'ALTA COMPLETA',
  );

  // Verificar si ambos existen y son mayores a 0
  if (alta && altaCompleta && alta.total > 0 && altaCompleta.total > 0) {
    // Si ALTA es mayor a ALTA COMPLETA, restar el total de ALTA COMPLETA de ALTA
    if (alta.total > altaCompleta.total) {
      alta.total -= altaCompleta.total;
      alta.gestion = 'ALTA INICIADA';
      altaCompleta.gestion = 'ALTA COMPLETADA';
    }
  }
  // Mapear y cambiar el nombre de gestiones que no sean ALTA o ALTA COMPLETA
  const kpiAltaGestiones = altaGestiones.map((gestion) => {
    if (
      gestion.gestion.toUpperCase() !== alta?.gestion &&
      gestion.gestion.toUpperCase() !== altaCompleta?.gestion
    ) {
      gestion.gestion = 'ALTA MANUAL';
    }

    return {
      GESTION: formatGestionName(gestion.gestion), // Nombre del alta
      TOTAL: gestion.total, // Total del alta
    };
  });
  return kpiAltaGestiones;
};

export const getTopGestionesStatusSinAgenda = (data, topN = 15) => {
  if (!data) {
    console.info('getTopGestionesStatusSinAgenda >> No data ');
    return [];
  }
  const copydata = [...data];
  const sinAgendaGestiones = copydata.filter((gestion) =>
    gestion.gestion.startsWith('SIN AGENDA -'),
  );

  const groupedGestiones = sinAgendaGestiones.reduce((acc, curr) => {
    const nombreRestante = curr.gestion.replace('SIN AGENDA -', '').trim();

    const entry = acc.find((item) => item.GESTION === nombreRestante);
    if (entry) {
      entry.TOTAL += parseInt(curr.total, 10);
    } else {
      acc.push({ GESTION: nombreRestante, TOTAL: parseInt(curr.total, 10) });
    }

    return acc;
  }, []);

  const kpiSinAgendaRes = groupedGestiones.sort((a, b) => b.TOTAL - a.TOTAL).slice(0, topN);

  return kpiSinAgendaRes;
};

export const getKpiGestionesByProfessional = (data) => {
  if (!data) {
    console.info('getKpiGestionesByProfessional >> No data ');
    return [];
  }
  const copydata = [...data];
  const groupedGestiones = copydata.reduce((acc, curr) => {
    const { gestion, professionalName, total } = curr;
    const totalInt = parseInt(total, 10);

    if (professionalName && professionalName.trim() !== '') {
      let tipo = gestion.toUpperCase();
      if (tipo.includes('TURNO PRESENCIAL') || tipo.includes('TURNO TELECONSULTA')) {
        tipo = 'TURNOS';
      } else if (tipo !== 'CANCELACION') {
        return acc;
      }

      const profEntry = acc.find((item) => item.PROFESSIONAL === professionalName);
      if (profEntry) {
        profEntry[tipo] += totalInt;
      } else {
        const newEntry = { PROFESSIONAL: professionalName, TURNOS: 0, CANCELACION: 0 };
        newEntry[tipo] = totalInt;
        acc.push(newEntry);
      }
    }

    return acc;
  }, []);

  const kpiByProfessional = groupedGestiones.every((gestion) => gestion.TURNOS === 0)
    ? groupedGestiones.sort((a, b) => b.CANCELACION - a.CANCELACION).slice(0, 10) // Ordenar por CANCELACION si todos los TURNOS son 0
    : groupedGestiones.sort((a, b) => b.TURNOS - a.TURNOS).slice(0, 10); // Ordenar por TURNOS en caso contrario
  return kpiByProfessional;
};

export const getKpiGestionesBySpecialty = (data) => {
  if (!data) {
    console.info('getKpiGestionesBySpecialty >> No data ');
    return [];
  }
  const copydata = [...data];
  const groupedGestiones = copydata.reduce((acc, curr) => {
    const { gestion, specialtyName, total } = curr;
    const totalInt = parseInt(total, 10);

    if (specialtyName && specialtyName.trim() !== '') {
      let tipo = gestion.toUpperCase();
      if (tipo.includes('TURNO PRESENCIAL') || tipo.includes('TURNO TELECONSULTA')) {
        tipo = 'TURNOS';
      } else if (tipo !== 'CANCELACION' && tipo !== 'EN AGENDA') {
        return acc;
      }

      const specialtyEntry = acc.find((item) => item.ESPECIALIDAD === specialtyName);
      if (specialtyEntry) {
        specialtyEntry[tipo] += totalInt;
      } else {
        const newEntry = { ESPECIALIDAD: specialtyName, TURNOS: 0, CANCELACION: 0, 'EN AGENDA': 0 };
        newEntry[tipo] = totalInt;
        acc.push(newEntry);
      }
    }

    return acc;
  }, []);

  const kpiBySpecialty = groupedGestiones.every((gestion) => gestion.TURNOS === 0)
    ? groupedGestiones.sort((a, b) => b.CANCELACION - a.CANCELACION).slice(0, 10) // Ordenar por CANCELACION si todos los TURNOS son 0
    : groupedGestiones.sort((a, b) => b.TURNOS - a.TURNOS).slice(0, 10); // Ordenar por TURNOS en caso contrario

  return kpiBySpecialty;
};

export const getKpiNotificationsByMonth = (data) => {
  const gestiones = [...data];
  const filteredGestiones = gestiones.filter(
    (gestion) =>
      gestion.gestion.toUpperCase() === 'NOTIFICACION' &&
      gestion.activeSession !== 'true' &&
      gestion.notificationType &&
      (removeAccents(gestion.notificationType.toLowerCase()).includes('confirmacion') ||
        removeAccents(gestion.notificationType.toLowerCase()).includes('cancelacion') ||
        removeAccents(gestion.notificationType.toLowerCase()).includes('recordatorio')),
  );

  const totalReminderResponse = {
    noRespondido: 0,
    cancelado: 0,
    confirmado: 0,
  };

  if (filteredGestiones.length === 0) return [];

  filteredGestiones.forEach((gestion) => {
    const total = parseInt(gestion.total, 10);
    if (gestion.reminderResponse === 'true') {
      totalReminderResponse.confirmado += total;
    } else if (gestion.reminderResponse === 'false') {
      totalReminderResponse.cancelado += total;
    } else {
      totalReminderResponse.noRespondido += total;
    }
  });

  const kpiNotificacionesRes = [
    { reminderResponse: 'NO RESPONDIDO', total: totalReminderResponse.noRespondido },
    { reminderResponse: 'CANCELADO', total: totalReminderResponse.cancelado },
    { reminderResponse: 'CONFIRMADO', total: totalReminderResponse.confirmado },
  ];

  return kpiNotificacionesRes;
};

export const getKpiOtherNotificationsByMonth = (data) => {
  const gestiones = [...data];
  const filteredGestiones = gestiones.filter(
    (gestion) =>
      gestion.gestion.toUpperCase() === 'NOTIFICACION' &&
      gestion.notificationType &&
      (removeAccents(gestion.notificationType.toLowerCase()).includes('alta') ||
        removeAccents(gestion.notificationType.toLowerCase()).includes('activacion')),
  );

  const kpiActivacionAlta = filteredGestiones.reduce((acc, curr) => {
    const gestionName = curr.notificationType;
    const total = parseInt(curr.total, 10);

    const existingGestion = acc.find((g) => g.GESTION === gestionName);
    if (existingGestion) {
      existingGestion.TOTAL += total;
    } else {
      acc.push({ GESTION: gestionName, TOTAL: total });
    }

    return acc;
  }, []);

  return kpiActivacionAlta;
};
export const getNoSpecialtyKpisByMonth = (data) => {
  if (!Array.isArray(data)) {
    console.error('Invalid input: `data` must be an array.');
    return [];
  }
  try {
    const formattedGestiones = data
      ?.map((doc) => {
        const docData = doc.data();
        const gestionValue = getGestionValue(docData);
        if (gestionValue) {
          return {
            type: docData.type,
            GESTION: gestionValue,
          };
        }
        return null;
      })
      ?.filter((item) => item !== null);

    if (formattedGestiones?.length === 0) {
      console.info('No hay gestiones especialidades_no');
      return [];
    }
    const totalItems = formattedGestiones.length;

    const groupedData = formattedGestiones.reduce((acc, item) => {
      const { GESTION } = item;
      if (!acc[GESTION]) {
        acc[GESTION] = { ...item, TOTAL: 1 };
      } else {
        acc[GESTION].TOTAL += 1;
      }
      acc[GESTION].PERCENTAGE = ((acc[GESTION].TOTAL / totalItems) * 100).toFixed(2);
      return acc;
    }, {});

    const sortedGroupedArray = Object.values(groupedData)
      .sort((a, b) => b.TOTAL - a.TOTAL)
      .map((value) => ({ specialtyNo: value.GESTION, ...value }))
      .slice(0, 15);

    return sortedGroupedArray;
  } catch (error) {
    console.error('getNoSpecialtyKpisByMonth', error);
    return [];
  }
};

const getGestionValue = (docData) => {
  if (docData?.specialtyNo) {
    if (Array.isArray(docData.specialtyNo)) {
      return docData.specialtyNo[0];
    } else if (typeof docData.specialtyNo === 'string') {
      return docData.specialtyNo;
    }
  }
  return null;
};

export const getKpiByMonth = (data, date) => {
  if (!data) {
    console.info('getKpiByMonth >> No data ');
    return [];
  }
  if (moment().format('YYYY-MM') === date) {
    date = moment().subtract(1, 'month').format('YYYY-MM');
  }
  const [year, month] = date.split('-');

  return [data.find((item) => item.year === year && item.month === month)] || [];
};

export const formatFunnelData = (rawData) => {
  const { totalChats, repeatedClientsSummaryPercentage } = rawData;
  const data = [];

  let sumAboveTen = 0;

  for (const key in repeatedClientsSummaryPercentage) {
    const value = Math.round((repeatedClientsSummaryPercentage[key] * totalChats) / 100);
    const repetitions = parseInt(key, 10);

    if (repetitions <= 9) {
      if (repetitions === 1) {
        data.push({ label: `Usuarios únicos`, value });
      } else {
        data.push({ label: `Usuarios repetidos ${repetitions} veces`, value });
      }
    } else {
      sumAboveTen += value;
    }
  }
  if (sumAboveTen > 0) {
    data.push({ label: `Usuarios repetidos: +10 veces`, value: sumAboveTen });
  }

  return data;
};

export const removeOldKpiStorageKeys = (dataKpiStorageAnual, isQuotaExceeded) => {
  if (!dataKpiStorageAnual || typeof dataKpiStorageAnual !== 'object') {
    console.warn('dataKpiStorageAnual is undefined, null, or not an object.');
    if (isQuotaExceeded)
      throw new Error(
        'removeOldKpiStorageKeys >> dataKpiStorageAnual is undefined and isQuotaExceeded',
      );
    return undefined;
  }
  const limitDataDate = isQuotaExceeded ? 1 : 2;
  const limitDate = moment().subtract(limitDataDate, 'months');
  Object.keys(dataKpiStorageAnual).forEach((key) => {
    const keyDate = moment(key.substring(0, 7), 'YYYY-MM');
    if (keyDate.isBefore(limitDate)) {
      delete dataKpiStorageAnual[key];
    }
  });
  const compressedData = LZString.compressToUTF16(JSON.stringify(dataKpiStorageAnual));
  // eslint-disable-next-line no-undef
  localStorage.setItem('dataKpiStorageAnual', compressedData);
  // eslint-disable-next-line no-undef
  localStorage.removeItem('dataChartStorageAnual');
  return dataKpiStorageAnual;
};

// Metodo para chequear el espacio del local storage cuando sea necesario
export const getLocalStorageAvailableSpace = () => {
  const localStorageLimit = 5 * 1024 * 1024; // 5 MB
  let totalSize = 0;

  // Recorremos todas las claves en localStorage para calcular el tamaño total ocupado
  // eslint-disable-next-line no-undef
  for (let i = 0; i < localStorage.length; i++) {
    // eslint-disable-next-line no-undef
    const key = localStorage.key(i);
    // eslint-disable-next-line no-undef
    const value = localStorage.getItem(key);
    totalSize += key.length + value.length;
  }

  const availableSpace = localStorageLimit - totalSize;

  console.log(`Espacio ocupado en localStorage: ${totalSize} bytes`);
  console.log(`Espacio disponible en localStorage: ${availableSpace} bytes`);

  return availableSpace;
};

export const isDataCompressed = (data) => {
  try {
    const decompressedData = LZString.decompressFromUTF16(data);
    return decompressedData !== null;
  } catch (error) {
    console.warn('isDataCompressed >> data is not compressed');

    return false;
  }
};

export const getLocalDataKpiStorageAnual = () => {
  // eslint-disable-next-line no-undef
  const dataKpiStorageAnualCompressed = localStorage.getItem('dataKpiStorageAnual');
  let dataKpiStorageAnual;

  if (dataKpiStorageAnualCompressed) {
    dataKpiStorageAnual = isDataCompressed(dataKpiStorageAnualCompressed)
      ? JSON.parse(LZString.decompressFromUTF16(dataKpiStorageAnualCompressed))
      : JSON.parse(dataKpiStorageAnualCompressed);
  } else {
    dataKpiStorageAnual = {};
    console.warn(
      'getLocalDataKpiStorageAnual no se encuentra en localStorage, inicializando con datos vacíos.',
    );
  }

  return dataKpiStorageAnual;
};
